import { render, staticRenderFns } from "./tutor-add.vue?vue&type=template&id=74bb9e3f&scoped=true&"
import script from "./tutor-add.vue?vue&type=script&lang=js&"
export * from "./tutor-add.vue?vue&type=script&lang=js&"
import style0 from "./tutor-add.vue?vue&type=style&index=0&id=74bb9e3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb9e3f",
  null
  
)

export default component.exports